import { render, staticRenderFns } from "./RouteCatalog.vue?vue&type=template&id=6a9dfcc8"
import script from "./RouteCatalog.vue?vue&type=script&lang=js"
export * from "./RouteCatalog.vue?vue&type=script&lang=js"
import style0 from "./RouteCatalog.vue?vue&type=style&index=0&id=6a9dfcc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports